import React from 'react';
import classNames from 'classnames';
import i18n from '../../i18n';
import useGTM from '../analytics/useGTM';
import Analytics from '../../utils/analytics';
import { NAVIGATION_ACTION } from '../analytics/analytics-constants';
function SignupToTranslateButton() {
    var fetchNavigation = useGTM().fetchNavigation;
    var handleClick = function () {
        document.dispatchEvent(new CustomEvent('open_signup_popup'));
        Analytics.trackGTM('button', fetchNavigation(NAVIGATION_ACTION.CLICK, 'signup_translate_button', 'sign_up'));
    };
    return (React.createElement("div", { id: "group-btn-translate" },
        React.createElement("button", { className: classNames('btn btn-xs btn-ajax'), onClick: handleClick }, i18n.t('home:page.homeview.translate.logout.cta'))));
}
export default SignupToTranslateButton;
